import {
    makeStyles,
    shorthands,
    Button,
    Caption1,
    tokens,
    Text,
    Card,
    CardHeader,
    CardPreview,
    CardProps,
  } from "@fluentui/react-components";
  import * as React from "react";
  import "./cardstyles.css"
  import { MoreHorizontal20Filled } from "@fluentui/react-icons";
  import Lib from "../lib"
import { Link } from "react-router-dom";

  const icons = {
    youtube:"/youtubeicon.svg",
    kaggle: "/kaggle.svg",
    medium: "/mediumicon.svg",
    github: "/githubicon.svg",
    udemy: "/udemy.svg",
    webapp: "/webapp.svg",
    linkedin: "/LinkedIn_icon.svg.png"
  }
    

  const useStyles = makeStyles({
    main: {
      ...shorthands.gap("16px"),
      display: "flex",
      flexWrap: "wrap",
    },
  
    card: {
      width: "400px",
      maxWidth: "100%",
      height: "fit-content",
    },
  
    caption: {
      color: tokens.colorNeutralForeground3,
    },
  
    smallRadius: {
      ...shorthands.borderRadius(tokens.borderRadiusSmall),
    },
  
    grayBackground: {
      backgroundColor: "black",
    },
  
    logoBadge: {
      ...shorthands.padding("5px"),
      ...shorthands.borderRadius(tokens.borderRadiusSmall),
      backgroundColor: "#FFF",
      boxShadow:
        "0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12)",
    },
  });
  
  const ContentCard= (props) => {
    const styles = useStyles();
  
    return (
      <Card className={styles.card} {...props}>
        <CardPreview
          className={styles.grayBackground}
        >
        <div className="container">
         <div className="links" >
            <div style={{marginTop:"5%"}}> 
            <Link to={`/${props.type}/${props.id}`}style={{textDecoration:"none"}} target="_blank">
                <Button style={{fontFamily:props.font}} size="large">View Details</Button>
            </Link>

            </div>
            <div style={{height:"5%"}}></div>
            <div className="ms-Grid" >
                <div className="ms-Grid-row" >
                    { props.links.split(",").map(link=>{
                    return <div className="ms-Grid-row ms-sm4" style={{margin:"5%",display:"flex", justifyContent:"center", alignItems:"center"}}>
                        <a  href={link} target="_blank"> 
                        {/* <div className="circle" style={{backgroundColor:"white"}}>     
                            <img className="imglink"src={process.env.PUBLIC_URL+icons[Lib.linkToKey(link)]} />
                        </div> */}
                        <Button style={{fontFamily:props.font}}>{Lib.linkToKey(link)}</Button>
                    </a>
                    </div>
                    })}
                    
                </div>
            </div>
            
          </div>
          <div> 
            <img

                className={[styles.smallRadius,"card_img"].join('')}
                src={props.thumbnail}
                alt="Presentation Preview"
                style={{width:"100%", height:"18em", objectFit:"cover",userDrag:"none", pointerEvents:"none"}}
            />
          </div>
        </div>
          
        </CardPreview>
  
        <CardHeader
          header={<Text style={{fontFamily:props.font}} weight="semibold">{props.title}</Text>}
          description={
            <Caption1 className={styles.caption} style={{fontFamily:props.font}} >{props.timestamp.toDate().toDateString()}</Caption1>
          }
          
        />
      </Card>
    );
  };
  
 
 export default ContentCard